/**
 * A simple centered message screen (loading / error states). Fills the space
 * left under the shared header when a view uses it, and still stands on its
 * own (ErrorBoundary) thanks to the minimum height.
 */
export function Centered({ children }: { children: React.ReactNode }) {
  return (
    <main className="flex min-h-[60vh] flex-1 items-center justify-center px-6 text-center font-mono text-sm text-muted">
      {children}
    </main>
  );
}
